export default __webpack_public_path__ + "static/media/redux.d81fad54.svg";